import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from './FloorChooser.module.css';

class FloorChooser extends Component {
  state = {
    selectedFloor: null
  }

  static props = {
    onUpdateSelectedFloor: PropTypes.func
  }

  setSelectedFloor(floor) {
    if (floor === this.state.selectedFloor) {
      floor = null;
    }
    this.setState({
      selectedFloor: floor
    });
    if (this.props.onUpdateSelectedFloor) this.props.onUpdateSelectedFloor(floor);
  }

  render() {
    const {
      selectedFloor
    } = this.state;

    return (
      <div>
        <div className={style.floor_chooser}>
          <div className={`${style.floor_button} ${selectedFloor === 1 ? style.active : ''}`} onClick={this.setSelectedFloor.bind(this, 1)}>
            <p>1階</p>
          </div>
          <div className={`${style.floor_button} ${selectedFloor === 2 ? style.active : ''}`} onClick={this.setSelectedFloor.bind(this, 2)}>
            <p>2階</p>
          </div>
          <div className={`${style.floor_button} ${selectedFloor === 3 ? style.active : ''}`} onClick={this.setSelectedFloor.bind(this, 3)}>
            <p>3階</p>
          </div>
          <div className={`${style.floor_button} ${selectedFloor === 4 ? style.active : ''}`} onClick={this.setSelectedFloor.bind(this, 4)}>
            <p>4階</p>
          </div>
        </div>
      </div>
    );
  }
}

export default FloorChooser;



// WEBPACK FOOTER //
// ./src/components/common/FloorChooser.js